export default __webpack_public_path__ + "7a26b2931c7a85ff7fb6dfe4df50b078.png";